'use strict';

export default {
  home: {
    title: `Ensure quality dental care`,
    meta: {
      description: `Ensure quality dental care`,
    },
  },
  
  infoDentists: {
    title: `VeriTooth for Dentists`,
    meta: {
      description: `The dental industry is in trouble, and we need your help. There isn’t a way to demonstrate quality while also building trust with patients. Find out VeriTooth is changing that.`,
    },
  },

  infoReviewers: {
    title: `Become a Verified Reviewer`,
    meta: {
      description: `You can play a critical role is solving a dental industry wide problem. Patients don’t have a solid way to assess the quality of work they received. Find out how you can help change that.`,
    },
  },

  dashboard: {
    title: `Dashboard`,
    meta: {
      description: `User dashboard`,
    },
  },

  register: {
    title: `Register`,
    meta: {
      description: `Sign up to VeriTooth`,
    },
  },

  login: {
    title: `Sign In`,
    meta: {
      description: `Sign into VeriTooth`,
    },
  },

  notFound: {
    title: `Not Found`,
    meta: {
      description: `This page was not found.`,
      noIndex: true,
    },
  },

  terms: {
    title: `T&Cs`,
    meta: {
      // description: `Terms page description`,
      noIndex: true,
    },
  },

  privacy: {
    title: `Privacy Policy`,
    meta: {
      // description: `Privacy policy description`,
      noIndex: true,
    },
  },
};



// WEBPACK FOOTER //
// ./client/models/meta.js